import * as React from "react";
import * as ReactDOM from "react-dom";
import * as $ from "jquery";

import { Provider, connect } from "react-redux";
import { createStore, applyMiddleware } from "redux";
import createSagaMiddleware from 'redux-saga';
import { select, call, put, takeEvery, takeLatest, delay, all } from 'redux-saga/effects';

import reducer from './botcomponent/reducer';
import MySaga from './botcomponent/sagafunc';

import { changetitle } from './commonfunc/common';


interface BotState {
    baseJson: any; // 表示に使うページ
    CurrentPages: number; // 現在のページ
    PageMaxPost: number; // １ページあたりの表示数
    DateOrigin: any; // 日付
}

/**
 * 
 */
const fgetURL = () => {
    const url = document.getElementById("fetchUrl");
    //console.log("url is ",url.innerText);
    return url.innerText;
}
const fget_date_origin = () => {
    const dateorigin = document.getElementById("date_origin");
    //console.log("url is ",url.innerText);
    return dateorigin.innerText;
}
/**
 * 
 */
const fgetPages = () => {
    const pages = document.getElementById("pages");
    //console.log("url is ",url.innerText);
    return Number(pages.innerText);
}

/**
 * 
 */
class ListApp extends React.Component<any, BotState>{

    state: BotState = {
        baseJson: [],
        CurrentPages: fgetPages(),
        PageMaxPost: 100,
        DateOrigin: fget_date_origin()
    }
    componentWillMount = () => {
    }
    componentWillUnmount = () => {
    }
    componentDidMount() {
        // initialize saga
        this.props.dispatch({ type: "Ajax_Get_Post", url: fgetURL() })
    }
    componentWillReceiveProps() {
    }



    /**
     * 
     * 
     * render
     * 
     * 
     */
    public render() {
        //console.log("baseJson is ", this.props.baseJson);
        if (this.props.baseJson.count != 0) {

            // botu
            //const start = this.state.CurrentPages * this.state.PageMaxPost;
            //const goal = (this.state.CurrentPages + 1) * this.state.PageMaxPost;
            //const baseJson = this.props.baseJson.data.slice(start, goal);
            const baseJson = this.props.baseJson.data;
            console.log("baseJson is ", baseJson);


            /** page list */
            //const PagingAll = Math.ceil(this.props.baseJson.count / this.state.PageMaxPost);
            const PagingAll = this.props.baseJson.allPage;
            const PagingAllArray = [...Array(PagingAll).keys()];
            const PagingTT = PagingAllArray.map((v: any, i: any) => {
                const urlLinks = '/list/index.php?date=' + this.state.DateOrigin + '&pages=' + (v + 1);
                return (
                    <li className="item">
                        <a href={urlLinks}>
                            {v + 1}
                        </a>
                    </li>
                )
            });
            /** */
            const PagingList =
                <p>
                    <ul className="paging">{PagingTT}</ul>
                    {this.state.CurrentPages + 1} / {this.props.baseJson.allPage}　ページ（ 全 {this.props.baseJson.count} 件）
                </p>

            //const ItemList = this.props.baseJson.data.map((v: any, i: any) => {
            const ItemList = baseJson.map((v: any, i: any) => {

                const urls = "/list/detail.php?date=" + this.state.DateOrigin + "&pages=" + (this.state.CurrentPages + 1) + "&ids=" + v.id;

                if ( i < 9 ) {
                    return (
                        <li className="img-auc-item" key={i}>
                            <a href={urls}>{changetitle(v.title)}
                            <img src={v.main_image} alt={v.title} />
                            </a>
                        </li>
                    );
                } else {
                    return (
                        <li className="auc-item" key={i}>
                            <a href={urls}>{changetitle(v.title)}</a>
                            {/* <img src={v.main_image} alt={v.title} /> */}
                        </li>
                    );
                }

            });

            return (
                <div>
                    {PagingList}
                    <hr />
                    <ul id="auclists">
                        {ItemList}
                    </ul>
                    <hr />
                    {PagingList}
                </div>
            );
        } else {
            return (
                <p>
                    now loading
                </p>
            );

        }
    }

}







/**
 * 1-3 set App
 */
const App: any = (() => {
    const mapStatetoProps = (state: any) => {
        return { ...state };
    }
    return connect(mapStatetoProps)(ListApp);
})();

/**
 * 3-4 sagaMiddleware
 */
const sagaMiddleware = createSagaMiddleware();
const store = createStore(reducer, applyMiddleware(sagaMiddleware));
sagaMiddleware.run(MySaga);




ReactDOM.render(
    <div>
        <Provider store={store} >
            <App />
        </Provider>
    </div>
    ,
    document.getElementById("app")
);
